(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    function toggleSearchBar() {
      const searchBar = document.getElementById('headerSearchBar');
      const input = document.getElementById('search-input-bar');
      if (searchBar) {
        searchBar.classList.toggle('active');
        if (searchBar.classList.contains('active') && input) {
          setTimeout(() => input.focus(), 100);
        }
      }
    }

    function toggleSearchModal() {
      const modal = document.getElementById('searchModal');
      const input = document.getElementById('search-input-mobile');
      if (modal) {
        modal.classList.toggle('active');
        if (modal.classList.contains('active')) {
          if (input) setTimeout(() => input.focus(), 100);
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    }

    function toggleMobileSidebar() {
      const sidebar = document.getElementById('mobileSidebarMenu');
      if (sidebar) {
        sidebar.classList.toggle('active');
        if (sidebar.classList.contains('active')) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    }

    function closeMobileSidebar() {
      const sidebar = document.getElementById('mobileSidebarMenu');
      if (sidebar && sidebar.classList.contains('active')) {
        sidebar.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    function initMobileSubmenu() {
      const submenuToggles = document.querySelectorAll('.mobile-submenu-toggle');
      submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const menuItem = this.closest('.mobile-menu-item, .mobile-submenu-item');
          if (menuItem) {
            menuItem.classList.toggle('active');
          }
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      const searchToggleBtn = document.getElementById('searchToggleBtn');
      if (searchToggleBtn) {
        searchToggleBtn.addEventListener('click', toggleSearchBar);
      }

      const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
      if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', toggleMobileSidebar);
      }

      const mobileSidebarClose = document.getElementById('mobileSidebarClose');
      if (mobileSidebarClose) {
        mobileSidebarClose.addEventListener('click', closeMobileSidebar);
      }

      const mobileSidebarOverlay = document.getElementById('mobileSidebarOverlay');
      if (mobileSidebarOverlay) {
        mobileSidebarOverlay.addEventListener('click', closeMobileSidebar);
      }

      initMobileSubmenu();

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          const modal = document.getElementById('searchModal');
          const searchBar = document.getElementById('headerSearchBar');
          const sidebar = document.getElementById('mobileSidebarMenu');
          if (modal && modal.classList.contains('active')) {
            toggleSearchModal();
          }
          if (searchBar && searchBar.classList.contains('active')) {
            toggleSearchBar();
          }
          if (sidebar && sidebar.classList.contains('active')) {
            closeMobileSidebar();
          }
        }
      });
    });

    window.toggleSearchBar = toggleSearchBar;
    window.toggleSearchModal = toggleSearchModal;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"] && !Shopify.designMode) return;
  try {
    
  let slideIndex = 1;

  function showSlide(n) {
    const slides = document.querySelectorAll('.hero-slider .slide');
    const dots = document.querySelectorAll('.hero-slider .dot');
    
    if (n > slides.length) { slideIndex = 1; }
    if (n < 1) { slideIndex = slides.length; }
    
    slides.forEach(slide => slide.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));
    
    if (slides[slideIndex - 1]) {
      slides[slideIndex - 1].classList.add('active');
    }
    if (dots[slideIndex - 1]) {
      dots[slideIndex - 1].classList.add('active');
    }
  }

  function changeSlide(n) {
    showSlide(slideIndex += n);
  }

  function currentSlide(n) {
    showSlide(slideIndex = n);
  }

  // Auto-play slider
  document.addEventListener('DOMContentLoaded', function() {
    const slides = document.querySelectorAll('.hero-slider .slide');
    
    // Initialize slider - show first slide
    if (slides.length > 0) {
      showSlide(1);
    }
    
    if (slides.length > 1) {
      setInterval(function() {
        changeSlide(1);
      }, 5000); // Change slide every 5 seconds
    }

    // FAQ Accordion
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const faqItem = this.parentElement;
        const isActive = faqItem.classList.contains('active');
        
        // Close all FAQ items
        document.querySelectorAll('.faq-item').forEach(item => {
          item.classList.remove('active');
          item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        });
        
        // Open clicked item if it wasn't active
        if (!isActive) {
          faqItem.classList.add('active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    // Product Gallery
    const gallerySlides = document.querySelectorAll('.product-gallery-slide');
    const galleryThumbnails = document.querySelectorAll('.product-gallery-thumbnail');
    const galleryPrev = document.querySelector('.product-gallery-prev');
    const galleryNext = document.querySelector('.product-gallery-next');
    let currentSlide = 0;

    function showSlide(index) {
      gallerySlides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      galleryThumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === index);
      });
      currentSlide = index;
    }

    if (galleryThumbnails.length > 0) {
      galleryThumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => showSlide(index));
      });
    }

    if (galleryPrev && galleryNext) {
      galleryPrev.addEventListener('click', () => {
        const newIndex = currentSlide > 0 ? currentSlide - 1 : gallerySlides.length - 1;
        showSlide(newIndex);
      });

      galleryNext.addEventListener('click', () => {
        const newIndex = currentSlide < gallerySlides.length - 1 ? currentSlide + 1 : 0;
        showSlide(newIndex);
      });
    }

    // Product Variants
    const variantOptions = document.querySelectorAll('.product-variant-option');
    const variantSelect = document.getElementById('product-variant-select');
    const priceWrapper = document.querySelector('.product-price-wrapper');
    const addToCartBtn = document.querySelector('.product-add-to-cart');

    if (variantOptions.length > 0 && variantSelect) {
      variantOptions.forEach(option => {
        option.addEventListener('click', function() {
          const optionName = this.dataset.optionName;
          const optionValue = this.dataset.optionValue;

          // Update active state
          document.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(opt => {
            opt.classList.remove('active');
          });
          this.classList.add('active');

          // Update selected text
          const selectedSpan = document.getElementById(`selected-${optionName.toLowerCase().replace(/\s+/g, '-')}`);
          if (selectedSpan) {
            selectedSpan.textContent = optionValue;
          }

          // Find matching variant
          const options = {};
          document.querySelectorAll('.product-variant-option.active').forEach(opt => {
            options[opt.dataset.optionName] = opt.dataset.optionValue;
          });

          const optionKeys = Object.keys(options);
          const matchingOption = Array.from(variantSelect.options).find(opt => {
            return optionKeys.every((key, index) => {
              return opt.dataset[`option${index}`] === options[key];
            });
          });

          if (matchingOption) {
            variantSelect.value = matchingOption.value;
            const selectedVariant = variantSelect.options[variantSelect.selectedIndex];

            // Update price
            if (selectedVariant.dataset.price) {
              const priceElement = priceWrapper.querySelector('.product-price, .product-price-sale');
              if (priceElement) {
                priceElement.textContent = selectedVariant.dataset.price;
              }
            }

            // Update availability
            if (addToCartBtn) {
              if (selectedVariant.dataset.available === 'true') {
                addToCartBtn.disabled = false;
                addToCartBtn.querySelector('.product-add-to-cart-text').textContent = 'Sepete Ekle';
              } else {
                addToCartBtn.disabled = true;
                addToCartBtn.querySelector('.product-add-to-cart-text').textContent = 'Stokta Yok';
              }
            }
          }
        });
      });
    }

    // Quantity Controls
    const quantityInput = document.getElementById('product-quantity');
    const quantityDecrease = document.querySelector('.product-quantity-decrease');
    const quantityIncrease = document.querySelector('.product-quantity-increase');

    if (quantityDecrease && quantityIncrease && quantityInput) {
      quantityDecrease.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });

      quantityIncrease.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentValue + 1;
      });
    }


    // Form submission
    const productForm = document.getElementById('product-form');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        const submitBtn = this.querySelector('.product-add-to-cart');
        if (submitBtn && submitBtn.disabled) {
          e.preventDefault();
          return false;
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
